import { FileError } from "react-dropzone";

export interface FormModel {
    surchargenumber: string;
    phone: string;
    ticketType: string;
    travelcardnumber: string;
    ticketNumber: string;
    description: string;
    firstname: string;
    lastname: string;
    email: string;
    agecheck: string;
    appealforwho: string;
    reporterEmail: string;
}

export interface UploadableFile {
    id: number;
    file: File;
    data: string;
    size: number;
    errors: FileError[];
}

export enum TimePeriod {
    Year,
    Month,
    Week,
    Day,
    Hour,
    Minute,
    Second,
    MilliSecond,
}

// interface SelectedJourney {
//     fromName: string;
//     toName: string;
//     date: string;
//     travelTime: string;
//     journeyKey: string;
//     line: string;
//     switches: string;
//     unformattedDate: string,
// }

// interface Stop {
//     PlaceName: string;
//     OgtType: string;
//     Ll: [number, number];
//     Id: number;
// }

// export interface TravelSearchModel {
//     selectedJourneyFrom: Stop | null;
//     selectedJourneyTo: Stop | null;
//     journeyDate: string;
//     journeyTime: string;
// }